/**
 */
const ThemeAnt = {
    fontFamily: '\'Montserrat\', sans-serif',
    antPrimaryColor: '#0A3250',
}

module.exports = { ThemeAnt }

